import styled from 'styled-components'

export const Wrapper = styled.div`
  text-align: center;
  padding: 12px 16px;
  margin-top: auto;
  font-size: 14px;
`
